// Google maps, JavaScript API
// ref https://www.javadrive.jp/google-maps-javascript/
window.initMap = function(){
    let windowWidth = document.documentElement.clientWidth;
    let mapZoom = 17;
    if(windowWidth < 600){
        mapZoom = 15;
    }
    const myLatLng = new google.maps.LatLng(35.655054139963156, 139.6988013909249);
    const icon = {
        url:  '/wp-content/themes/undrop2/assets/img/gmap-pin.png',
        scaledSize: new google.maps.Size(40, 40), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(20, 20) // anchor
    };
    const style = [{
        featureType: 'all',
        elementType: 'all',
        stylers: [
        { saturation: -100 }
        ]
    }];

    //embed
    const map = new google.maps.Map(document.getElementById('gmap'), {
        zoom: mapZoom,
        center: myLatLng,
        //mapId: '',
        styles: style
    });
    new google.maps.Marker({
        position: myLatLng,
        map:map,
        icon:icon,
        title: 'undrop.jp',
    });

}


